import React from "react";
import { UseFormReturn } from "react-hook-form";
import { UserRoleSelect } from "./user-role-select";

interface IUserForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const UserForm: React.FC<IUserForm> = ({ loading, form, submit }) => {
  return (
    <>
      <div className="w-full">
        <div className="flex flex-wrap">
          <div className="w-full mb-2">
            <p className="label">Prénom</p>
            <input
              className="w-full input"
              type="text"
              {...form.register("firstname", { required: "name required" })}
              placeholder="firstname"
            />
          </div>
          <div className="w-full mb-2">
            <p className="label">Nom</p>
            <input
              className="w-full input"
              type="text"
              {...form.register("lastname", { required: "name required" })}
              placeholder="lastname"
            />
          </div>
          <div className="w-full mb-2">
            <p className="label">Email</p>
            <input
              className="w-full input"
              type="text"
              {...form.register("email", { required: "name required" })}
              placeholder="email"
            />
          </div>
          <UserRoleSelect form={form} />x
          <div className="w-full mb-2">
            <p className="label">Mot de passe</p>
            <input
              className="w-full input"
              type="text"
              {...form.register("password", { required: "password required" })}
              placeholder="Mot de passe"
            />
          </div>
          <div className="w-full mb-2">
            <p className="label">confirmation</p>
            <input
              className="w-full input"
              type="text"
              {...form.register("confirmation", {
                required: "confirmation required",
              })}
              placeholder="Confirmation Mot de passe"
            />
          </div>
        </div>
      </div>

      <div className="w-full mt-2">
        <div className="btn" onClick={submit}>
          {loading ? "Chargement" : "Valider"}
        </div>
      </div>
    </>
  );
};
